<template>
  <div style="display: flex;text-align: center;align-items: center;height: 100px"  :data-theme="themeMode">
    <div style="flex: 1;text-align: left;height: 100%;  user-select: text;">
      <div class="goBackButtonBox" :style="{ height: isAlignCenter ? '100%' : 'auto' }">
        <el-button class="goBackButton" :style="{ height: isAlignCenter ? '100%' : 'auto' }" @click="goBack">
          <el-icon class="el-icon-arrow-left goBackIcon"></el-icon>
        </el-button>
      </div>
    </div>
    <div style="flex: 4;">
      <slot name="body"></slot>
    </div>
    <div style="flex: 1"></div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      if (this.backUrl == "") {
        this.$router.go(-1);//切换语言后返回原来的页面 上一页
      }else{
        this.$router.push({path:this.backUrl});
      }
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  props: {
    isAlignCenter:{
      type: Boolean,
      default: false
    },
    backUrl: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';

.goBackButtonBox{
  display: inline-block;
}

.goBackButton{
  border-radius: 0;
  border-color: transparent;

  margin: 0;
  padding: 20px 20px;
  background-color: transparent;
}

.goBackIcon {
  font-size: 25px;
  @include font_color("goBackIconColor");
}

</style>



// WEBPACK FOOTER //
// src/components/goBackButton/goBackButton.vue